/**
 * BadgeVisual.jsx
 * Componente visual de la insignia. Renderiza SVG con Tailwind.
 * Diseñado para ser compatible con html2canvas (sin fuentes externas).
 * Recibe `forwardRef` para que el padre pueda capturar el nodo.
 */
import React, { forwardRef } from 'react';

const BadgeVisual = forwardRef(function BadgeVisual({ badge }, ref) {
  const {
    badgeLabelSnapshot = 'Insignia EPL',
    programTitleSnapshot = '',
    displayNameSnapshot = '',
    claimedAt,
    verificationId
  } = badge;

  const dateStr = claimedAt
    ? new Date(claimedAt).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })
    : '';

  return (
    <div
      ref={ref}
      className="inline-flex flex-col items-center bg-white rounded-2xl border border-slate-200 shadow-lg p-8 w-full max-w-lg"
      style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
    >
      {/* Icono hex SVG */}
      <div className="mb-5">
        <svg width="112" height="112" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <polygon
            points="48,4 88,26 88,70 48,92 8,70 8,26"
            fill="#0891b2"
            stroke="#0e7490"
            strokeWidth="2"
          />
          <polygon
            points="48,12 80,30 80,66 48,84 16,66 16,30"
            fill="#06b6d4"
          />
          {/* Estrella */}
          <polygon
            points="48,26 51.6,37.6 64,37.6 54.2,44.8 57.8,56.4 48,49.2 38.2,56.4 41.8,44.8 32,37.6 44.4,37.6"
            fill="white"
            opacity="0.95"
          />
          {/* Check circle */}
          <circle cx="48" cy="68" r="8" fill="white" opacity="0.9" />
          <path d="M44 68l3 3 6-6" stroke="#0891b2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {/* Etiqueta principal */}
      <p className="text-xs font-semibold uppercase tracking-widest text-cyan-600 mb-1.5 text-center">
        EduTech Pulse Lab
      </p>
      <h2 className="text-lg font-bold text-slate-900 text-center leading-snug mb-1">
        {badgeLabelSnapshot}
      </h2>

      {/* Separador */}
      <div className="w-12 h-px bg-slate-200 my-3" />

      {/* Nombre del titular — elemento más dominante */}
      {displayNameSnapshot && (
        <p className="text-base font-bold text-slate-900 text-center mb-1">{displayNameSnapshot}</p>
      )}

      {/* Fecha */}
      {dateStr && (
        <p className="text-xs text-slate-400 text-center mb-2">{dateStr}</p>
      )}

      {/* ID verificación */}
      {verificationId && (
        <p className="text-[10px] text-slate-300 text-center leading-relaxed break-all">
          Verificación: {verificationId}
        </p>
      )}
    </div>
  );
});

export default BadgeVisual;
